import { mergeClass } from "../utils";

/**
 * Tooltip hover component
 * Ensure parent element has 'group/tooltip' class
 * @param param0
 * @returns
 */
export const Tooltip = ({
  className,
  children,
}: {
  className?: string;
  children: string | React.ReactNode;
}) => (
  <div className="relative w-0 h-0 pointer-events-none">
    <div
      className={mergeClass(
        "transition absolute left-[0.4rem] bottom-[calc(100%+0.7rem)]",
        "px-2 py-0.5 rounded-tl-lg rounded-tr-lg rounded-br-lg",
        "text-black font-normal text-[0.7rem] text-left opacity-0",
        "whitespace-nowrap group-hover/tooltip:opacity-100 bg-white drop-shadow-md",
        className
      )}
    >
      {children}
    </div>
    <div
      style={{
        width: 0,
        height: 0,
        borderBottom: "4px solid transparent",
        borderLeft: "4px solid white",
      }}
      className={
        "transition absolute opacity-0 group-hover/tooltip:opacity-100 left-[0.4rem] px-2 top-[calc(100%-0.7rem)]"
      }
    />
  </div>
);
